$(function() {
  $('a.btn-not-member').bind('click', function(e) {
    $('.ws-registration-select').remove();
    $('.ws-registration-form').fadeIn();
    $("html, body").animate({ scrollTop: $(document).height()-$(window).height() }, 1000);
    e.preventDefault();
  });
});
